import { Injectable } from '@angular/core';
import { Business } from '../models/domain/Business';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessService extends BaseService<Business> {
  private readonly rowCountSubject: BehaviorSubject<number>;
  public readonly rowCount$: Observable<number>;
  private http: HttpClient;

  constructor(http: HttpClient, loadingService: LoadingService) {
    super(http, `${environment.apiUrl}/v1/business`, loadingService);
    this.http = http;
    this.rowCountSubject = new BehaviorSubject<number>(0);
    this.rowCount$ = this.rowCountSubject.asObservable();
  }
}